/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MenuFold = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M21 4H7v2h14zm0 7H11v2h10zm0 7H7v2h14zM1.99 8.81 3.4 7.4 8 12l-4.6 4.6L2 15.17 5.17 12z" />
  </Icon>
);
